import styled from '@emotion/styled';
import { Block as EmptyIcon } from '@mui/icons-material';
import ColorOption from './ColorOption';
import { Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line react-refresh/only-export-components
export const ColorOptionWithIcon = styled(ColorOption)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.divider}`,
  '.MuiSvgIcon-root': {
    color: theme.palette.text.secondary,
  },
}));

type NoColorButtonProps = {
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const NoColorButton = ({ onClick }: NoColorButtonProps) => (
  <Tooltip
    title={
      <FormattedMessage id="portfolio.challenge.color_picker.color_options.no_color" />
    }
  >
    <ColorOptionWithIcon color="transparent" onClick={onClick}>
      <EmptyIcon fontSize="small" />
    </ColorOptionWithIcon>
  </Tooltip>
);

export default NoColorButton;
